<template>
    <div class="distribution-campaigns">
        <loader v-if="loading" />
        <v-row v-else>
            <v-col>
                <v-card>
                    <v-card-text>
                        <v-subheader>
                            <v-row>
                                <v-col cols="9">
                                    Navn
                                </v-col>
                                <v-col cols="2">
                                    Partner
                                </v-col>
                                <v-col cols="1"></v-col>
                            </v-row>
                        </v-subheader>
                        <v-list class="striped-list">
                            <v-list-item v-for="campaign in filteredCampaigns" :key="campaign.name" :to="`/campaigns/${campaign.uniqueId}`">
                                <v-list-item-content>
                                    <v-row align="center">
                                        <v-col cols="9">
                                            {{ campaign.name }}
                                        </v-col>
                                        <v-col cols="2">
                                            <v-chip v-if="campaign.partner">Partner</v-chip>
                                        </v-col>
                                        <v-col cols="1">
                                            <v-icon>fa-eye</v-icon>
                                        </v-col>
                                    </v-row>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    data () {
        return {
            loading: true,
            campaigns: null
        }
    },
	computed: {
        filteredCampaigns () {
            return this.campaigns.filter(campaign => campaign.level === this.level)
        },
        department () {
            return this.$store.state.main.department || this.$store.getters['distribution/department']
        },
        level () {
            return this.$store.state.distribution.level
        }
    },
    methods: {
        async getData() {
            this.loading = true
            let response = await this.$http().get(`/distribution/${this.department}/campaigns`)
            this.campaigns = response.data
            this.loading = false
        }
    },
    watch: {
        department: function () {
            this.getData()
        }
    },
    created () {
        this.getData()
    }
}
</script>